import type { HTMLAttributes } from 'react'
import { cx } from './cx'
import s from './Card.module.css'

/**
 * Card — the standard surface container (border + radius + shadow) that pages
 * kept re-declaring as inline `<section style={…}>`. `glass` is the frosted
 * variant used by the copilot bar and ⌘K palette; `pad` adds the default inset.
 */
export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  glass?: boolean
  pad?: boolean
}
export function Card({ glass, pad, className, children, ...rest }: CardProps) {
  return <div className={cx(s.card, glass && s.glass, pad && s.pad, className)} {...rest}>{children}</div>
}
